import { WithPermission } from "@components/WithPermission";
import { AMPLITUDE_EVENTS } from "@constants/analytics";
import { NAV_ICON_COLOR_CLASSNAME } from "@constants/layout";
import QuestionIcon from "@lyteflo/assets/icons/question.svg?react";
import { Button } from "@lyteflo/components";
import { FEATURE, PortalRoutes } from "@lyteflo/types";
import { LYTEFLO_SUPPORT_URL } from "@lyteflo/utils";
import { trackEvent } from "@services/analytics";
import { navDestinationFromHref } from "@utils/analytics";
import { useTranslation } from "react-i18next";

export const HelpButton = () => {
  const { t } = useTranslation();

  return (
    <WithPermission feature={FEATURE.VIEW_HELP}>
      <Button
        asChild
        variant="ghost"
        color="gray"
        className="lf-h-8 lf-flex lf-items-center lf-gap-2 lf-m-1 lf-p-1"
      >
        <a
          href={LYTEFLO_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t("navigation.help")}
          onClick={() =>
            trackEvent(AMPLITUDE_EVENTS.CLICK_NAV, {
              destination: navDestinationFromHref(PortalRoutes.HELP),
            })
          }
        >
          <QuestionIcon
            className={`lf-shrink-0 ${NAV_ICON_COLOR_CLASSNAME} lf-h-6 lf-w-6`}
          />
        </a>
      </Button>
    </WithPermission>
  );
};
